import api from "./api";

// Job Status service (CRUD)
// GET    /job-status
// GET    /job-status/:id
// POST   /job-status
// PATCH  /job-status/:id
// DELETE /job-status/:id

export async function getJobStatuses() {
  const res = await api.get("/job-status");
  return Array.isArray(res) ? res : [];
}

export async function getJobStatusById(statusId) {
  if (statusId === undefined || statusId === null || statusId === "") {
    throw new Error("statusId is required");
  }
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.get(`/job-status/${idNum}`);
}

export async function createJobStatus(payload) {
  return api.post("/job-status", payload || {});
}

export async function updateJobStatus(statusId, payload) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/job-status/${idNum}`, body);
}

export async function deleteJobStatus(statusId) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.delete(`/job-status/${idNum}`);
}
